module.exports = __webpack_public_path__ + "files/2aa576a1a177e72e145e4681cbd96a61.png";